import { render, staticRenderFns } from "./IdeasoftProductSearch.vue?vue&type=template&id=7c140b13"
import script from "./IdeasoftProductSearch.vue?vue&type=script&lang=js"
export * from "./IdeasoftProductSearch.vue?vue&type=script&lang=js"
import style0 from "./IdeasoftProductSearch.vue?vue&type=style&index=0&id=7c140b13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports